module.exports = __webpack_public_path__ + "static/img/bg-rank.ce3ca4dc.jpg";